module.exports = __webpack_public_path__ + "static/media/noesis.67c8feb6.svg";